// utils/csvExportConfig.ts

export type CSVExportField<T> = {
  label: string;
  key: keyof T;
};

import {
  ResponsePlanItem,
  ResponseReportItem,
  ResponseShipmentPackage,
} from "../services/OpenAPI";

export const shipmentCSVExportFields: CSVExportField<
  ResponseShipmentPackage & {
    shippedDate: string;
    userName: string;
    planName: string;
    shipmentConfirmationId: string;
  }
>[] = [
  { label: "出荷日", key: "shippedDate" },
  { label: "ユーザー名", key: "userName" },
  { label: "縦", key: "boxLength" },
  { label: "横", key: "boxWidth" },
  { label: "高さ", key: "boxHeight" },
  { label: "重量", key: "boxWeight" },
  { label: "箱数", key: "boxCount" },
  { label: "問い合わせNO", key: "shipNum" },
  { label: "名前", key: "planName" },
  { label: "納品番号", key: "shipmentConfirmationId" },
];

// レポート画面のアイテムCSV
export const reportItemCSVFields: {
  label: string;
  key: keyof ResponseReportItem;
}[] = [
  { label: "拠点", key: "baseName" },
  { label: "ユーザー", key: "userName" },
  { label: "ステータス", key: "status" },
  { label: "入荷日", key: "arrivedDate" },
  { label: "商品名", key: "itemName" },
  { label: "ASIN", key: "asin" },
  { label: "SKU", key: "sku" },
  { label: "FNSKU", key: "fnsku" },
  { label: "JAN", key: "jan" },
  { label: "セット数", key: "setNum" },
  { label: "納品数", key: "arriveNum" },
  { label: "入荷総数", key: "actualShippingNum" },
  { label: "実出荷単位数", key: "shippingNum" },
  { label: "賞味期限", key: "expiryDate" },
  { label: "備考", key: "memo" },
  { label: "出荷日", key: "shippedDate" },
  { label: "納品番号", key: "planName" },
  { label: "シール", key: "stickerNum" },
  { label: "返送", key: "returnNum" },
  { label: "破棄", key: "destructionNum" },
];

// レポート画面のプランCSV
export const reportPlanCSVFields: {
  label: string;
  key: keyof ResponsePlanItem;
}[] = [
  { label: "出荷日", key: "shippedDate" },
  { label: "ユーザー名", key: "userName" },
  { label: "縦", key: "boxLength" },
  { label: "横", key: "boxWidth" },
  { label: "高さ", key: "boxHeight" },
  { label: "重量", key: "boxWeight" },
  { label: "箱数", key: "boxCount" },
  { label: "問い合わせNO", key: "shipNum" },
  { label: "名前", key: "planName" },
];
